import { createEntityAdapter } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { SavedSearchCriteriaResponse } from 'types/entity';

export const searchCriteriaReadAdapter = createEntityAdapter<SavedSearchCriteriaResponse>({
  selectId: (model) => model.search_criteria_id,
  sortComparer: (e1, e2) => {
    if (e1.search_criteria_id > e2.search_criteria_id) {
      return 1;
    }
    return e1.search_criteria_id === e2.search_criteria_id ? 0 : -1;
  },
});

export const {
  selectById: selectCriteriaById,
  selectIds: selectCriteriaIds,
  selectEntities: selectCriteriaEntities,
  selectAll: selectAllCriteria,
  selectTotal: selectTotalCriteria,
} = searchCriteriaReadAdapter.getSelectors<RootState>((state) => state.searchCriteriaRead);
